import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

const managerRoutes: RouteConfig = {
  path: '/product',
  component: Layout,
  meta: {
    title: 'product',
    icon: 'component',
    alwaysShow: true
  },
  children: [
    {
      path: 'productManage',
      name: 'Product Manage',
      component: () => import('@/views/product/productManage.vue'),
      meta: {
        title: 'productManage',
        icon: 'example',
        activeMenu: '/product/productManage'
      }
    },
    {
      path: 'accountManage',
      name: 'Account Manage',
      component: () => import('@/views/product/accountManage.vue'),
      meta: {
        title: 'accountManage',
        icon: 'money',
        activeMenu: '/product/accountManage'
      }
    },
    {
      path: 'walletAddress',
      name: 'Wallet Address',
      component: () => import('@/views/product/walletAddress.vue'),
      meta: {
        title: 'walletAddress',
        icon: 'skill',
        activeMenu: '/product/walletAddress'
      }
    },
    {
      path: 'accountGroup',
      name: 'Account Group',
      component: () => import('@/views/product/accountGroup.vue'),
      meta: {
        title: 'accountGroup',
        icon: 'skill',
        activeMenu: '/product/accountGroup'
      }
    },
    // {
    //   path: 'antAccountGroup',
    //   name: 'Account Group',
    //   component: () => import('@/views/product/antAccountGroup.vue'),
    //   meta: {
    //     title: 'antAccountGroup',
    //     icon: 'skill',
    //     activeMenu: '/product/antAccountGroup'
    //   }
    // },
    {
      path: 'smsLog',
      name: 'SMS Log',
      component: () => import('@/views/product/smsLog.vue'),
      meta: {
        title: 'smsLog',
        icon: 'skill',
        activeMenu: '/product/smsLog'
      }
    },
    {
      path: 'gcashAccount',
      name: 'Gcash Account',
      component: () => import('@/views/product/gcashAccount.vue'),
      meta: {
        title: 'gcashAccount',
        icon: 'example',
        activeMenu: '/product/gcashAccount'
      }
    },
    {
      path: 'exceptionTask',
      name: 'Abnormal Order',
      component: () => import('@/views/task/exceptionTask/index.vue'),
      meta: {
        title: 'bankBill',
        icon: 'bug',
        activeMenu: '/product/exceptionTask'
      }
    },
    {
      path: 'rechargeCurrency',
      name: 'Recharge Currency',
      component: () => import('@/views/product/rechargeCurrency/index.vue'),
      meta: {
        title: 'rechargeCurrency',
        icon: 'zhichu',
        activeMenu: '/product/rechargeCurrency'
      }
    },
    {
      path: 'subAccount',
      name: 'Sub Account',
      component: () => import('@/views/product/subAccount/index.vue'),
      meta: {
        title: 'subAccount',
        icon: 'example',
        activeMenu: '/product/subAccount'
      }
    },
    {
      path: 'smsAccount',
      name: 'SMS Account',
      component: () => import('@/views/product/smsAccount/index.vue'),
      meta: {
        title: 'smsAccount',
        icon: 'example',
        activeMenu: '/product/smsAccount'
      }
    },
    {
      path: 'cardAccount',
      name: 'Card Account',
      component: () => import('@/views/product/cardAccount.vue'),
      meta: {
        title: 'cardAccount',
        icon: 'money',
        activeMenu: '/product/cardAccount'
      }
    },
    {
      path: 'smsManage',
      name: 'SMS Manage',
      component: () => import('@/views/product/smsManage.vue'),
      meta: {
        title: 'smsManage',
        icon: 'skill',
        activeMenu: '/product/smsManage'
      }
    }
  ]
}

export default managerRoutes
